import React from 'react';

import {
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  privateColor,
} from '../../library/constants';
import {
  getNodeFromNodeObjsWithPrId,
  // truncateWord,
  urlGet,
  isMobilePhone,
 } from '../../library/calc';
import SinglePartner from './singlepartner';

class Multipartners extends SinglePartner {

  getMultiplePartnerTR({partnerObj, partnerChildrenDivs, marriageId}){

      const { nodeObjs, stopStageClickPropagation, addNodeFormFocus, openAddNodeForm, onClickEdit, reloadCanvasTree } = this.props;

      let partnerFullname = partnerObj.nm;
      // partnerFullname = titleCase(partnerFullname);
      // const maxWidth = ( this.props.immediateFamVersion === 'addbox' ? 27: 35)
      // partnerFullname = truncateWord({str:partnerFullname, length: maxWidth, useWordBoundary: false})

      if(urlGet('nodeIs') === "n") partnerFullname = `${partnerObj.nm} - ${partnerObj.n}`;
      if(urlGet('nodeIs') === "prId") partnerFullname = `${partnerObj.nm} - ${partnerObj.prId}`;

      let otherParnerGenderChoice = (this.props.nodeObj.g === 'm' ? 'wife': 'husband');
      otherParnerGenderChoice = (partnerObj.g === 'u' ? 'spouse': otherParnerGenderChoice)

      let colorOfGender = (partnerObj.g === 'm' ? maleDefaultColor: femaleDefaultColor);
      if(partnerObj.g === 'u'){
        colorOfGender = unGenderedDefaultColor;
      }

      if(typeof(partnerObj.nvp) !== 'undefined'){
        colorOfGender = privateColor;
      }

      let isUnknownPartner = false;
      if(parseInt(partnerObj.n, 10) < 0){
        isUnknownPartner = true;
      }

      let canAddNode = false;
      if(this.props.nodeObj.a === 1){
        canAddNode = true;
      }

      const isGhost = () => {
        return typeof(partnerObj.nt) !== 'undefined'
      }

      return (
      <tr key={`trPartner${partnerObj.n}`}>
          <td className='family-list'>
            <div>
              <div  className='flip-anchor-bullet' style={{
                color: `${colorOfGender}`,
              }}>◉&nbsp;
              </div>
              <div className="flip-anchor-link"  onClick={()=>{
                    if((isUnknownPartner || isGhost())){
                      if(!isMobilePhone()){
                        if(!canAddNode) return;
                        openAddNodeForm({
                          node: addNodeFormFocus,
                          relationShip: otherParnerGenderChoice,
                          marriageId: partnerObj.marriageId,
                          nodeIsGhost: true,
                        });
                      }
                      return;
                    } else {
                      this.onClick(partnerObj);
                    }
                  }}
              >
                {partnerFullname}
              </div>
                <div>
                  &nbsp;&nbsp;
                  <span
                    className={ `svgicon ${(isGhost() ? 'hide': '')}`  }
                    style={( isUnknownPartner ? {display: 'none'}: this.getIconStyle().tree)}
                    onClick={()=>{
                      if(isUnknownPartner) return;

                      if( this.props.chartType === 'fan') this.props.refocusFanChart({prId: partnerObj.prId})
                      else reloadCanvasTree(partnerObj.prId);
                      // reloadCanvasTree(partnerObj.prId);
                    }}
                  >&nbsp;
                  </span>
                  <span
                    className={ `svgicon ${( typeof(partnerObj.e) === 'undefined' ? 'hide': '')}`   }
                    style={( isUnknownPartner ? {display: 'none'}: this.getIconStyle().edit)}
                    onClick={()=>{
                      if(isUnknownPartner) return;
                      const n = getNodeFromNodeObjsWithPrId({nodeObjs, prId: partnerObj.prId, fromWhere: 'addbox'});
                      onClickEdit(n, partnerObj.prId);
                    }}
                  >&nbsp;
                  </span>
                </div>
            </div>

            {

              canAddNode && this.props.immediateFamVersion === 'addbox' ?

                <div className='partner-children'>
                  &nbsp;&nbsp;
                  {
                    this.buildAddLinks({
                      stopStageClickPropagation,
                      openAddNodeForm,
                      maleRelation: 'son',
                      femaleRelation: 'daughter',
                      node: addNodeFormFocus,
                      marriageId
                    })
                  }
                </div>

                :

                null

            }

            {(typeof(partnerChildrenDivs) !== 'undefined' ? partnerChildrenDivs: null)}
          </td>
        </tr>
      );
  }

  AddDomTableRowsforPartnersWithNoChildren({partnersWithChildNodeIds, partnerWithChildrenDomHash}){

    const immediateFam = this.props.nodeObj.immediateFam;

    const partnersNodeObjs = immediateFam.partners;


    const partnersWithNoChildrenNodesId = partnersNodeObjs.filter((partnersObj) =>{
      return !partnersWithChildNodeIds.includes(partnersObj.n.toString())
    });


    partnersWithNoChildrenNodesId.map((partnerObj)=>{
      let trDom = this.getMultiplePartnerTR({partnerObj, marriageId: partnerObj.marriageId})
      partnerWithChildrenDomHash[partnerObj.n] = trDom;
      return trDom;
    });


    return {partnerWithChildrenDomHash};

  }

  getMultiplePartnersWithChildrenDom = (idx) =>{

    let partnersWithChildNodeIds = [];
    let partnerChildrenDivs = [];
    let partnerWithChildrenDomHash = {};

    const { nodeObjs, onClickEdit, reloadCanvasTree/*, flipVersion*/ } = this.props;
    const immediateFam = this.props.nodeObj.immediateFam;
    const partnerOrder = immediateFam.partnerOrder;

    const partnersObj = immediateFam.partnersObj;

    for( let partnerNodeId in partnersObj){

      partnerChildrenDivs = [];

      const childrenNodesIdArray = partnersObj[partnerNodeId].childrenNodesIds;

      partnerChildrenDivs = childrenNodesIdArray.map((childNodesId)=>{

        const childObj = this.getNodeObjFromImmedFamily({nodeId: childNodesId, arrayOfNodeObjs: immediateFam.children});

        let childFullName = childObj.nm;
        // childFullName = titleCase(childFullName);
        // const maxWidth = ( this.props.immediateFamVersion === 'addbox' ? 27: 35);
        // childFullName = truncateWord({str:childFullName, length: maxWidth, useWordBoundary: false})

        if(urlGet('nodeIs') === "n") childFullName = `${childObj.nm} - ${childObj.n}`;
        if(urlGet('nodeIs') === "prId") childFullName = `${childObj.nm} - ${childObj.prId}`;

        let colorOfGender = (childObj.g === 'm' ? maleDefaultColor: femaleDefaultColor);
        if(childObj.g === 'u'){
          colorOfGender = unGenderedDefaultColor;
        }

        if(typeof(childObj.nvp) !== 'undefined'){
          colorOfGender = privateColor;
        }

        return (
          <div key={`partner-children${childNodesId}`} className='partner-children'>
            <div className='flip-anchor-bullet' style={{
              color: `${colorOfGender}`,
            }}>◉&nbsp;
            </div>
            <div className='flip-anchor-link' onClick={()=>{
                  this.onClick(childObj);
                }}
            >
              {childFullName}
            </div>
            <div>
              &nbsp;&nbsp;
              <span
                className={ `svgicon` }
                style={this.getIconStyle().tree}
                onClick={()=>{
                  //hidePedigreeAddbox();
                  console.log(`this.props.chartType: `, this.props.chartType);
                  if( this.props.chartType === 'fan') this.props.refocusFanChart({prId: childObj.prId})
                  else reloadCanvasTree(childObj.prId);
                  // reloadCanvasTree(childObj.prId);
                }}
              >&nbsp;
              </span>
              <span
                className={ `svgicon ${( typeof(childObj.e) === 'undefined' ? 'hide': '')}`  }
                style={this.getIconStyle().edit}
                onClick={()=>{
                  const n = getNodeFromNodeObjsWithPrId({nodeObjs, prId: childObj.prId, fromWhere: 'addbox'});
                  onClickEdit(n, childObj.prId);
                }}
              >&nbsp;
              </span>
            </div>
          </div>
        );

      });

      let partnerObj = this.getNodeObjFromImmedFamily({nodeId: partnerNodeId, arrayOfNodeObjs: immediateFam.partners});

      partnersWithChildNodeIds.push(partnerNodeId);

      const trDom = this.getMultiplePartnerTR({partnerObj, partnerChildrenDivs, marriageId: partnerObj.marriageId});
      partnerWithChildrenDomHash[partnerNodeId] = trDom;

    } // ENDFOR


    const domTableRowsforPartnersWithChildrenIncludesBastardChildreObj = this.AddDomTableRowsforPartnersWithNoChildren({partnersWithChildNodeIds, partnerWithChildrenDomHash});

    const partnerWithChildrenDom = typeof(partnerOrder) !== 'undefined' && partnerOrder.map((nodeId)=>{
      return domTableRowsforPartnersWithChildrenIncludesBastardChildreObj.partnerWithChildrenDomHash[nodeId];
    })
    return ( typeof(partnerOrder) !== 'undefined' ? partnerWithChildrenDom: null);
  }

}

export default Multipartners;

